import axios from "@/interceptors/axios";
import { normalizeAuthError } from "@/server/authErrors";
import { clearIdentity } from "@/server/authStorage";

const AUTH_REQUEST_CONFIG = Object.freeze({ skipUserToken: true });
const responseData = (response) => {
  const body = response?.data ?? response;
  return body?.data ?? body;
};

const authRequest = async (operation, request) => {
  try {
    return await request();
  } catch (error) {
    throw normalizeAuthError(error, operation);
  }
};

export const login = async (email, password) => authRequest("start", async () => {
  const response = await axios.post("/api/login", { email, password }, AUTH_REQUEST_CONFIG);
  const data = responseData(response);
  if (!data?.auth?.access_token || !data?.user) throw new Error("invalid_auth_response");
  return data;
});

export const startLogin = login;

export const fetchSession = async () => authRequest("session", async () => {
  const response = await axios.get("/api/auth/session");
  const data = responseData(response);
  if (!data?.user) throw new Error("invalid_session_response");
  return data;
});

export const logout = async () => {
  try {
    await axios.post("/api/logout");
  } finally {
    clearIdentity();
  }
};
